import { useState, useEffect } from 'react'
import { Clock, MapPin } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/shadcn/select'
import { TIME_ZONES } from './timezone'

interface CalendarControlsProps {
  selectedTimeZone: string
  onTimeZoneChange: (timeZone: string) => void
  onScrollToCurrentTime: () => void
}

export function CalendarControls({ selectedTimeZone, onTimeZoneChange }: CalendarControlsProps) {
  const getCurrentTime = () => {
    return new Date().toLocaleTimeString('en-US', {
      timeZone: selectedTimeZone,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    })
  }

  const [currentTime, setCurrentTime] = useState(getCurrentTime())

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(getCurrentTime())
    }, 1000)

    return () => clearInterval(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTimeZone])

  return (
    <div className="flex items-center gap-6">
      {/* Time Zone Selector */}
      <div className="flex items-center gap-2">
        <MapPin className="h-4 w-4 text-slate-500" />
        <Select value={selectedTimeZone} onValueChange={onTimeZoneChange}>
          <SelectTrigger className="border-slate-200 bg-white/80 transition-colors hover:border-slate-300">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {TIME_ZONES.map((tz) => (
              <SelectItem key={tz.value} value={tz.value}>
                <div className="flex items-baseline gap-2">
                  <span className="text-sm">{tz.label}</span>
                  <span className="text-xs text-slate-500">{tz.offset}</span>
                </div>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      {/* Separator */}
      <div className="h-5 w-px bg-slate-300"></div>

      {/* Current Time Display */}
      <div className="flex items-center gap-2 rounded-md border border-slate-200/60 bg-white/60 px-3 py-1.5 text-sm text-slate-600">
        <Clock className="h-4 w-4" />
        <span className="font-medium">{currentTime}</span>
      </div>

      {/* Go to Now Button */}
      {/* <Button
        onClick={onScrollToCurrentTime}
        variant="default"
        size="sm"
        className="flex items-center gap-2 bg-[#6864ff] text-white shadow-md transition-all duration-200 hover:bg-[#4a36f5] hover:shadow-lg">
        <Clock className="h-4 w-4" />
        Go to Now
      </Button> */}
    </div>
  )
}
